import React, { FC, useEffect, useMemo, useState, useRef, memo } from "react"
import SyncableModel from "../../../../database/SyncableModel"
import { Appearance, ScrollView } from "react-native"
import { PlanktonMultiMeasurementForm as ModelForm, ModelCreateScreen } from "../../../../components"
import { CompositeScreenProps, useIsFocused } from "@react-navigation/native"
import { MultiMeasurement as Model } from "../../../../database"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { exitWalkthrough, startWalkthrough } from "react-native-walkthrough"
import formWalkthrough from "../../../../guides/form-walkthrough"
import { translate } from "../../../../i18n"

const FormWalkthrough: FC<{
  scrollViewRef?: { current: ScrollView }
}> = memo(observer(function FormWalkthrough(props) {
  const { scrollViewRef } = props
  const { userStore } = useStores()
  const { user } = userStore
  const isFocused = useIsFocused()

  useEffect(() => {
    if (!isFocused || !user || user?.state?.add_plankton_coachmark_shown) return undefined
    startWalkthrough(formWalkthrough(
      [
        {
          id: 'plankton-multi-measurement-form-first',
          content: translate("planktonMultiMeasurementForm.planktonTooltip"),
          placement: 'top',
          tooltipProps: {},
        },
        {
          id: 'plankton-multi-measurement-second',
          content: translate("paramTooltip"),
          placement: 'top',
          tooltipProps: {},
        }
      ], () => {
        userStore.updateData({ state: { add_plankton_coachmark_shown: true } })
          .finally(() => userStore.getUser())
        if (scrollViewRef && scrollViewRef.current)
          return scrollViewRef.current.scrollTo({ y: 0 })
      },
    ))
    return () => isFocused && exitWalkthrough();
  }, [isFocused, scrollViewRef, user, userStore])

  return null
}))

export const PlanktonMultiMeasurementCreateScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function PlanktonMultiMeasurementCreateScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmId, farmStore },
    planktonMultiMeasurementStore: modelStore,
  } = useStores()

  const [ model, setModel ] = useState<SyncableModel>(null)
  const scrollViewRef = useRef<ScrollView>(null)

  const initialValues = useMemo<any>(() => {
    const data = (model ? model.toArray() : params)
    return {
      farm_id: farmId,
      ...data,
    }
  }, [farmId, model, params])

  useEffect(() => {
    const planktonMultiMeasurement = farmStore.planktonMultiMeasurements.find((m) => m.id === params.id);
    if (planktonMultiMeasurement) {
      const model = Model.hydrate({ ...planktonMultiMeasurement });
      setModel(model)
    }
  }, [farmStore, params.id, setModel])

  return (<>
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      initialValues={initialValues}
      modelStore={modelStore}
      model={model}
      scrollViewRef={scrollViewRef}
    />
    <FormWalkthrough scrollViewRef={scrollViewRef} />
  </>)
});
